export default __webpack_public_path__ + "static/media/drag_white.eb26875c.svg";